import * as React from "react";

type Props = {
  data: any;
  onLoaded?: (data: any) => void;
};

export default class BOGraphQLLoader extends React.Component<Props> {
  componentWillReceiveProps(nextProps: Props) {
    if (
      !nextProps.data.error &&
      !nextProps.data.loading &&
      this.props.data.loading &&
      nextProps.onLoaded
    ) {
      nextProps.onLoaded(nextProps.data);
    }
  }

  render() {
    const { data } = this.props;
    if (data.loading) {
      return <div>Loading ...</div>;
    } else if (data.error) {
      return <div>Error</div>;
    } else {
      return React.Children.map(this.props.children, child =>
        React.cloneElement(child as any, { data: this.props.data })
      );
    }
  }
}
